// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"b3999b1c","333":"693f4d37","431":"260c4d71","786":"8b653dba","995":"b3999b1c"}[chunkId] + ".chunk.css";
};